/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MedicationDetails from './medication-details';
import MedicationDetailsDetail from './medication-details-detail';
import MedicationDetailsUpdate from './medication-details-update';
import MedicationDetailsDeleteDialog from './medication-details-delete-dialog';

const MedicationDetailsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MedicationDetails />} />
    <Route path="new" element={<MedicationDetailsUpdate />} />
    <Route path=":id">
      <Route index element={<MedicationDetailsDetail />} />
      <Route path="edit" element={<MedicationDetailsUpdate />} />
      <Route path="delete" element={<MedicationDetailsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MedicationDetailsRoutes;
